import styled from 'util/style'

const NavItem = styled.div`
  flex: 1;
  text-align: center;
  margin: 55px 20px;
  z-index: 2;

  @media (max-width: 640px) {
    margin: 10px 5px;
  }

  a {
      color: #666;
      text-transform: uppercase;
      letter-spacing: 0.3px;
      font-weight: light;
      font-size: 13px;
      text-decoration: none;

      &:hover {
          color: #333;
          padding-bottom: 2px;
          border-bottom: 1px solid #DDD;
      }
  }
`

export default NavItem
